"use strict";
/* globals module */
/**
 * @module applicationSettingsRoute
 * @description Baasic Application Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Application Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var ApplicationSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ApplicationSettingsRoute, _super);
    function ApplicationSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'applications/{?embed,fields}';
        _this.updateRoute = 'applications/';
        return _this;
    }
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param options Query resource options object.
     * @example applicationSettingsRoute.get();
     **/
    ApplicationSettingsRoute.prototype.get = function (options) {
        return _super.prototype.baseGet.call(this, this.getRoute, undefined, options);
    };
    /**
     * Parses update route; this route doesn't expose any properties.
     * @method
     * @param data An application object used to update application settings of the specified application resource.
     * @example applicationSettingsRoute.update();
     **/
    ApplicationSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    ApplicationSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ApplicationSettingsRoute);
    return ApplicationSettingsRoute;
}(common_1.BaseRoute));
exports.ApplicationSettingsRoute = ApplicationSettingsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
